
import { NgModule } from '@angular/core';

import { AccidentIndicatorEditProvider } from './accident-indicator-edit.provider';
import { AccidentIndicatorListProvider } from './accident-indicator-list.provider';

export * from './accident-indicator-edit.provider';
export * from './accident-indicator-list.provider';

export {
  AccidentIndicatorListProvider,
  AccidentIndicatorEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    AccidentIndicatorEditProvider,
    AccidentIndicatorListProvider
  ]
})
export class AccidentIndicatorBackendModule { }
